import { render, staticRenderFns } from "./nopage.vue?vue&type=template&id=b786a27c&scoped=true"
import script from "./nopage.vue?vue&type=script&lang=js"
export * from "./nopage.vue?vue&type=script&lang=js"
import style0 from "./nopage.vue?vue&type=style&index=0&id=b786a27c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b786a27c",
  null
  
)

export default component.exports